import HELPER from './HELPER';

/**
 * setFontWeight
 * @param params
 */
export const setFontWeight = (params: {
  $activePanel: JQuery;
  $self: JQuery;
  style: string;
  screenType: string;
  selector?: string;
  inputSelector?: string;
}) => {
  const { $activePanel, $self, style, screenType, selector, inputSelector = '#fontWeight' } = params;
  let fontWeight = HELPER.getValueFromCSS($self, style, 'font-weight', screenType, selector);
  if (!fontWeight || fontWeight == '') {
    const $selector = selector ? $self.find(selector) : $self;
    const cssValue = $selector.css('font-weight');
    fontWeight = cssValue || ($activePanel.find(inputSelector).attr('default_value') as string);
    if (fontWeight == '700') fontWeight = 'bold';
    if (fontWeight == 'normal') fontWeight = '400';
  }
  $activePanel.find(inputSelector).val(fontWeight).attr('value', fontWeight).trigger('value-change');
};

interface GetFontWeightParams {
  $activePanel: JQuery;
  inputSelector?: string;
}

/**
 * Get design option for font weight
 * @returns
 */
export const getFontWeightDesignOption = (params: GetFontWeightParams) => {
  const { $activePanel, inputSelector = '#fontWeight' } = params;
  return {
    key: 'font-weight',
    value: $activePanel.find(inputSelector).val(),
  };
};

/**
 * getFontWeightBoldValue
 * @returns
 */
export const getFontWeightBoldValue = (params: GetFontWeightParams) => {
  const { $activePanel, inputSelector = '#fontWeight' } = params;
  const inputValue = $activePanel.find(inputSelector).val() || '';
  return ['bold', '700', 700].includes(inputValue as string | number) ? 'bold' : '';
};
